import React, {/* useEffect, useState, Fragment */} from 'react';
import { /*Dropdown, DropdownToggle, DropdownMenu, DropdownItem,*/ Button } from 'reactstrap';
import {Link, useHistory} from 'react-router-dom';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { logout } from 'redux/modules/auth/action';
import { ListGroup, ListGroupItem } from 'reactstrap';

const MobileTabMenu = ({ auth, logout, toggler, ...props }) => {
    let history = useHistory();

    const active = [
        {
            name: 'Products',
            link: '/products',
        },
        {
            name: 'Organizations',
            link: '/organizations',
        },
        {
            name: 'Users',
            link: '/combined-users'
        },
        {
            name: 'Nudge Emails',
            link: '/nudge-emails',
        },
        {
            name: 'FB accounts',
            link: '/fb-accounts',
        },
        {
            name: 'Global Sources',
            link: '/global_sources',
        },
        {
            name: 'Logout',
            link: '/',
        },
    ];

    const menu = auth.isAuthenticated ? active : [];

    const handleChanePage = (item) => {
        if (item.name === 'Logout') {
            history.push(item.link);
            toggler(false);
            logout();
            return;
        }

        toggler(false);
        history.push(item.link);
    };

    return (
        <div
            className="userMenuMobAndTab d-flex flex-column"
            style={{
                zIndex: 99999999,
                position: 'absolute',
                top: '55px',
                left: '0px',
                width: '100%',
                padding: '10px',
                background: 'white',
            }}
        >
            {auth.isAuthenticated === false && (
                <div className="d-flex justify-content-around align-items-center" style={{ width: '100%', marginBottom: '10px' }}>
                    <Link style={{ width: '33%' }} to="/">
                        <Button
                            onClick={() => toggler(false)}
                            className="w-100 calltoaction-button"
                        >
                            Sign In
                        </Button>
                    </Link>
                </div>
            )}
            <ListGroup className="align-self-start w-100">
                {menu.map((item) => {
                    return (
                        <ListGroupItem style={{ color: '#0f1c52' }} active={item.name === 'Sign Up' && true} key={item.name} onClick={() => handleChanePage(item)} action>
                            {item.name}
                        </ListGroupItem>
                    );
                })}
                {/*<ListGroupItem tag="a" href="#" action>Cras justo odio</ListGroupItem>*/}
                {/*<ListGroupItem tag="a" href="#" action>Dapibus ac facilisis in</ListGroupItem>*/}
                {/*<ListGroupItem tag="a" href="#" action>Morbi leo risus</ListGroupItem>*/}
                {/*<ListGroupItem tag="a" href="#" action>Porta ac consectetur ac</ListGroupItem>*/}
            </ListGroup>
        </div>
    );
};

const mapStateFromProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateFromProps, { logout })(withRouter(MobileTabMenu));
